document.addEventListener('DOMContentLoaded', () => {
  const serviceFilter = document.getElementById('service-filter');
  const industryFilter = document.getElementById('industry-filter');
  const viewAllButton = document.getElementById('view-all');
  const cards = document.querySelectorAll('.portfolio-card-outer');
  const cardsToShow = parseInt(document.querySelector('.portfolio-cards').dataset.cardsToShow) || 3;

  function updateCardsVisibility() {
    const serviceValue = serviceFilter.value;
    const industryValue = industryFilter.value;

    let visibleCount = 0;

    cards.forEach((card) => {
      const matchesService = serviceValue === 'all-services' || card.dataset.service === serviceValue;
      const matchesIndustry = industryValue === 'all-industries' || card.dataset.industry === industryValue;

      // Check if card matches both filters
      if (matchesService && matchesIndustry) {
        card.style.display = visibleCount < cardsToShow ? 'flex' : 'none';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    // Show or hide the "View All" button
    if (visibleCount > cardsToShow && serviceValue === 'all-services' && industryValue === 'all-industries') {
      viewAllButton.style.display = 'block';
    } else {
      viewAllButton.style.display = 'none';
    }
  }

  function showAllCards() {
    cards.forEach((card) => {
      card.style.display = 'flex';
    });
    viewAllButton.style.display = 'none'; // Hide the button after clicking
  }

  // Attach event listeners
  serviceFilter.addEventListener('change', updateCardsVisibility);
  industryFilter.addEventListener('change', updateCardsVisibility);

  if (viewAllButton) {
    viewAllButton.addEventListener('click', showAllCards);
  }

  // Initial setup
  updateCardsVisibility();
});
